<!--Footer Starts-->
<!--<footer>
  <div class="container-fluid">
    <p class="copyright text-center">
      Copyright  &copy;  {{currentDate | date: 'yyyy'}} <a id="healins" href="http://healins.com/">NCS</a>, All rights reserved.
    </p>

  </div>
</footer>-->
<!--Footer Ends-->



 
  <div class="container-fluid clearfix padding-top-0px">
    <span class="float-right margin-bottom-60px">
      Version 2.028.2602<span>&copy;</span> Copyrights 2020 HealinsLife. All Rights Reserved.
    </span>
  </div>
 
